<div class="legend-list">
    <div *ngFor="let item of items" class="legend-item">

        <div class="ds-legend" *ngIf="item.legendColor && !item.legendIcon">
            <div aria-hidden="true" class="ds-legend__dot ds-legend__dot--circle ds-legend__dot--line"
                [ngStyle]="{'background': 'var(' + item.legendColor + ')'}"></div>
            <div class="ds-legend__header">
                <span class="ds-legend__label ff-lato ff-body-s ff-bold" role="text"
                    aria-label="item.legendLabel">{{item.legendLabel}}</span>
            </div>
        </div>


        <div *ngIf="item.legendIcon && !item.legendColor" class="ds-legend">
            <ds-icon  style="color: var(--text-reading-1);" [attr.icon]="item.legendIcon" [attr.icon-size]="item.legendIconSize || '16'"
                [attr.icon-filled]="item.iconFilled">
            </ds-icon>


            <span class="legend-label ff-body-s ff-bold">{{ item.legendLabel
                }}</span>
        </div>
    </div>
</div>